<template>
    <!-- 标签组件 -->
    <el-tag 
    :type="type"
    :closable="closabled"
    :size="size"
    :effect="effect"
    :hit="hit"
    :color="color"
    @close="close(tag)"
    >   
        {{typeof tagText === 'function' ? tagText() : tagText}}
        <slot></slot>
    </el-tag>
</template>
<script>
export default {
    name:"VelTag",
    props:{
        tagText:[String, Number, Function],
        type:String,
        color:String,
        size:String,
        effect:String,
        isClosable:Boolean,
        isHit:Boolean,
    },
    data() {
        return {
            closabled:false,
            hit:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isClosable ? this.closabled = true : this.closabled
            this.isHit ? this.hit = true : this.hit
        },
        close(tag){
            this.$emit('close',tag)
        }
    }
}
</script>